var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 38,
    viewBox: "0 0 37 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5002 35.5755C9.35808 35.5755 1.92725 28.1447 1.92725 19.0026C1.92725 9.86052 9.35808 2.42969 18.5002 2.42969C27.6422 2.42969 35.0731 9.86052 35.0731 19.0026C35.0731 28.1447 27.6422 35.5755 18.5002 35.5755ZM18.5002 4.74219C10.6377 4.74219 4.23975 11.1401 4.23975 19.0026C4.23975 26.8651 10.6377 33.263 18.5002 33.263C26.3627 33.263 32.7606 26.8651 32.7606 19.0026C32.7606 11.1401 26.3627 4.74219 18.5002 4.74219Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 21.7005C17.8679 21.7005 17.3438 21.1764 17.3438 20.5443V12.8359C17.3438 12.2039 17.8679 11.6797 18.5 11.6797C19.1321 11.6797 19.6562 12.2039 19.6562 12.8359V20.5443C19.6562 21.1764 19.1321 21.7005 18.5 21.7005Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5002 26.7084C18.2997 26.7084 18.0993 26.6622 17.9143 26.5851C17.7293 26.508 17.5597 26.4001 17.4056 26.2614C17.2668 26.1072 17.1589 25.953 17.0818 25.7526C17.0047 25.5676 16.9585 25.3672 16.9585 25.1668C16.9585 24.9664 17.0047 24.7659 17.0818 24.5809C17.1589 24.3959 17.2668 24.2264 17.4056 24.0722C17.5597 23.9334 17.7293 23.8255 17.9143 23.7484C18.2843 23.5943 18.716 23.5943 19.086 23.7484C19.271 23.8255 19.4406 23.9334 19.5947 24.0722C19.7335 24.2264 19.8414 24.3959 19.9185 24.5809C19.9956 24.7659 20.0418 24.9664 20.0418 25.1668C20.0418 25.3672 19.9956 25.5676 19.9185 25.7526C19.8414 25.953 19.7335 26.1072 19.5947 26.2614C19.4406 26.4001 19.271 26.508 19.086 26.5851C18.901 26.6622 18.7006 26.7084 18.5002 26.7084Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoCircle);
export default __webpack_public_path__ + "static/media/info-circle.04e677a5657839b42f5ab973b9a6d44a.svg";
export { ForwardRef as ReactComponent };